import * as React from 'react';
import { Modal, Button, Label, Input, Form } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

class State {
    userName: any;
    newPassword: any;
    confirmPassword: any;
    userRole: any;
    expiryRule: any;
    selectedUser: string;
    showPasswordModal ?: boolean;
    message ?: string;
}

interface Props {
    title ?: string;
    showModal: boolean;
    handleModalClose: any;
    selectedRow ?: any;
    fetchUsers: any;
}

export default class AddEditWindow extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            userName:  '',
            userRole: '',
            newPassword: '',
            confirmPassword: '',
            expiryRule: 'never',
            selectedUser: '',
            showPasswordModal: false,
            message: ''
        });
        this.addUser = this.addUser.bind(this);
        this.editUser = this.editUser.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePasswordModalClose = this.handlePasswordModalClose.bind(this);
    }
    componentDidUpdate(prevProps: any) {

        if (this.props.selectedRow !== prevProps.selectedRow) {
            this.setState({
                userName: (this.props.selectedRow ? this.props.selectedRow.name : ''),
                selectedUser: (this.props.selectedRow ? this.props.selectedRow.name : ''),
                newPassword: '',
                confirmPassword: '',
                userRole: (this.props.selectedRow ? this.props.selectedRow.accessLevel : ''),
                expiryRule: (this.props.selectedRow ? this.props.selectedRow.expiryRule : '')
            });
        }
    }

    render() {

        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const userRoleOptions = [
            {value: 'admin', text: 'Admin'},
            {value: 'public', text: 'User'},
        ];
        const expiryOptions = [
            {value: 'never', text: 'never'},
            {value: 'every Monday', text: 'every Monday'},
            {value: 'every Tuesday', text: 'every Tuesday'},
            {value: 'every Wednesday', text: 'every Wednesday'},
            {value: 'every Thursday', text: 'every Thursday'},
            {value: 'every Friday', text: 'every Friday'},
            {value: 'every Saturday', text: 'every Saturday'},
            {value: 'every Sunday', text: 'every Sunday'},
            {value: '1st day of each month', text: '1st day of each month'},
            {value: '15th day of each month', text: '15th day of each month'},
            {value: 'every 60 days', text: 'every 60 days'},
            {value: 'every 90 days', text: 'every 90 days'},
            {value: 'every 120 days', text: 'every 120 days'}
        ];
        return (
            <React.Fragment>
                <Modal
                    open={this.props.showModal}
                    onClose={this.handleClose}
                    size="mini"
                    style={inlineStyle.modal}
                    closeOnDimmerClick={false}
                >
                    <Modal.Header>{this.props.title}</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    User Name:
                                </Label>
                                <Input
                                    type="text"
                                    value={this.state.userName}
                                    onChange={(event, data) => this.setState({userName: data.value})}
                                    disabled={(this.props.title === 'Edit User' ? true : false)}
                                />
                            </Form.Field>
                            <Form.Field>
                                {this.props.title === 'Edit User' ?
                                    <Label className="filterPanelLabel">
                                        New Password:
                                    </Label> :
                                    <Label className="filterPanelLabel">
                                        Password:
                                    </Label>
                                }
                                <Input
                                    type="password"
                                    value={this.state.newPassword}
                                    onChange={(event, data) => this.setState({newPassword: data.value})}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    Confirm Password:
                                </Label>
                                <Input
                                    type="password"
                                    value={this.state.confirmPassword}
                                    onChange={(event, data) => this.confirmPassword(event, data)}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    User Role:
                                </Label>
                                <Form.Select
                                    options={userRoleOptions}
                                    value={this.state.userRole}
                                    onChange={(event, data) => this.setState({userRole: data.value})}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    Password Expires:
                                </Label>
                                <Form.Select
                                    options={expiryOptions}
                                    value={this.state.expiryRule}
                                    onChange={(event, data) => this.setState({expiryRule: data.value})}
                                />
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            className="filterPanel-primary-btn modal-button-padding"
                            onClick={(this.props.title === 'Add User') ? this.addUser : this.editUser}
                        >
                            Save
                        </Button>
                        <Button className="filterPanel-secondary-btn modal-button-padding" onClick={(this.props.title === 'Add User') ? this.handleClose : this.props.handleModalClose}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showPasswordModal}
                    onClose={this.handlePasswordModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Error</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                {this.state.message}
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handlePasswordModalClose}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
    handlePasswordModalClose() {
        this.setState({
            showPasswordModal: false,
            message: ''
        });
    }
    confirmPassword(event: any, data: any) {
        this.setState({
            confirmPassword: data.value
        });
    }
    handleClose() {
        this.setState({
            userName: '',
            newPassword: '',
            confirmPassword: '',
            userRole: '',
            expiryRule: 'never',
            selectedUser: ''
        });
        this.props.handleModalClose();
    }

    addUser() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/config/users';

        if (this.state.userName === '' || this.state.userName === ' ' || this.state.userName === undefined) {
            this.setState({
              showPasswordModal: true,
              message: 'User name not supplied.'
            });
        } else if (this.state.confirmPassword !== this.state.newPassword) {
            this.setState({
              showPasswordModal: true,
              message: 'Password and Confirm Password do not match each other.'
            });
        } else if (this.state.newPassword === undefined || this.state.confirmPassword === undefined) {
            this.setState({
              showPasswordModal: true,
              message: 'Password not supplied.'
            });
        } else if (this.state.newPassword === '' || this.state.confirmPassword === '') {
            this.setState({
              showPasswordModal: true,
              message: 'Password not supplied.'
            });
        } else if (this.state.confirmPassword.length > 15) {
            this.setState({
              showPasswordModal: true,
              message: 'Supplied Password > 15 characters long.'
            });
        } else {
            let user = {
                'users': [{
                'name': this.state.userName,
                'password': this.state.confirmPassword,
                'accessLevel': this.state.userRole,
                'expiryRule': this.search(this.state.expiryRule)
            }]
            };
            axios.post(url, user)
                .then(function (response: any) {
                    if (response.status === 201) {
                        __this.handleClose();
                        __this.props.fetchUsers();
                    } else {
                        __this.setState({
                            showPasswordModal: true,
                            message: response.response.data.det
                        });
                        // tslint:disable-next-line:no-console
                        console.log('add user error, got ', response);
                    }
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('add user error, got: ', error);
                });
        }
    }

    search(nameKey: any) {
        const myArray = [
            {value: 0, text: 'never'},
            {value: 2, text: 'every Monday'},
            {value: 3, text: 'every Tuesday'},
            {value: 4, text: 'every Wednesday'},
            {value: 5, text: 'every Thursday'},
            {value: 6, text: 'every Friday'},
            {value: 7, text: 'every Saturday'},
            {value: 8, text: 'every Sunday'},
            {value: 9, text: '1st day of each month'},
            {value: 10, text: '15th day of each month'},
            {value: 11, text: 'every 60 days'},
            {value: 12, text: 'every 90 days'},
            {value: 13, text: 'every 120 days'}
        ];
        for (let i = 0; i < myArray.length; i++) {
            if (myArray[i].text === nameKey) {
                return myArray[i].value;
            }
        }
        return 0;
    }

    editUser() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/config/users';

        if (this.state.newPassword === '') {
            // do not update the password
            let user = {
                'users': [{
                    'name': this.state.userName,
                    'accessLevel': this.state.userRole,
                    'expiryRule': this.search(this.state.expiryRule)
                }]
            };
            axios.put(url, user)
                .then(function (response: AxiosResponse) {
                    if (response) {
                        __this.props.fetchUsers();
                        __this.props.handleModalClose();
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log('edit user error, got ', response);
                        __this.props.handleModalClose();
                    }
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('edit user error, got: ', error);
                });
        } else {
            if (this.state.confirmPassword !== this.state.newPassword) {
                this.setState({
                  showPasswordModal: true,
                  message: 'Password and Confirm Password do not match each other.'
                });
            } else if (this.state.newPassword === undefined || this.state.confirmPassword === undefined) {
                this.setState({
                  showPasswordModal: true,
                  message: 'Password not supplied.'
                });
            } else if (this.state.newPassword === '' || this.state.confirmPassword === '') {
                this.setState({
                    showPasswordModal: true,
                    message: 'Password not supplied.'
                });
            } else if (this.state.confirmPassword.length > 15) {
                this.setState({
                  showPasswordModal: true,
                  message: 'Supplied Password > 15 characters long.'
                });
            } else {
                let user = {
                    'users': [{
                        'name': this.state.userName,
                        'password': this.state.confirmPassword,
                        'accessLevel': this.state.userRole,
                        'expiryRule': this.search(this.state.expiryRule)
                    }]
                };
                axios.put(url, user)
                    .then(function (response: AxiosResponse) {
                        if (response) {
                            __this.props.fetchUsers();
                            __this.props.handleModalClose();
                        } else {
                            // tslint:disable-next-line:no-console
                            console.log('edit user error, got ', response);
                            __this.props.handleModalClose();
                        }
                    })
                    .catch(function (error: AxiosRequestConfig) {
                        // tslint:disable-next-line:no-console
                        console.log('edit user error, got: ', error);
                    });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/security/addEditWindow.tsx